module.exports = __webpack_public_path__ + "img/code.2c0610c0.svg";